import { render, staticRenderFns } from "./CatalogItem.vue?vue&type=template&id=0b0a58ae&scoped=true&"
import script from "./CatalogItem.vue?vue&type=script&lang=js&"
export * from "./CatalogItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0a58ae",
  null
  
)

export default component.exports